// Photos.jsx
import React, { useEffect, useMemo, useState } from "react";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import SC from "./style";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import { userAccessType } from "utils/lookUpTable";
import theme from "theme";
import Button from "InnoUI/components/Button";
import GetPermission from "../ListFileAndPermission/FileDetailsView/GetPermission";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { apiPost } from "api/callApi";
import { useSelector } from "react-redux";
import CatalogGrid from "./CatalogGrid";
import ShimmerCard from "views/Dashboard/ShimmerCard";
import InnoIcons from "@InnoIcons/";

const Photos = React.memo((props) => {
  const { permission, isLoading } = props;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const type = searchParams.get("type");

  const [catalogs, setCatalogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const getCatalogFiles = async () => {
    try {
      setLoading(true);
      const result = await apiPost("/v1/photos/getCatalogFiles", {
        projectId: projectId,
        type: type,
      });

      setCatalogs(result.catalogs || []);
      setLoading(false);
      console.log(result, "op");
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
    }
  };

  useEffect(() => {
    if (!currentProject?.id) return;
    getCatalogFiles();
  }, [currentProject?.id]);

  const filteredCatalogs = useMemo(() => {
    const q = (searchQuery || "").trim().toLowerCase();
    if (!q) return catalogs;
    return catalogs.filter((c) => {
      const name = (c.catalogName || c.name || "").toString().toLowerCase();
      return name.includes(q);
    });
  }, [catalogs, searchQuery]);

  if (permission === undefined || permission === null) return null;

  const handleMultipleUpload = () => {
    console.log("Multiple upload clicked");
    navigate(
      `/photos/multiupload?projectId=${projectId}&folderId=${folderId}&type=${type}&isbulk=false`
    );
  };
  const handleMultipleBulkUpload = () => {
    console.log("Multiple upload clicked");
    navigate(
      `/photos/multiupload?projectId=${projectId}&folderId=${folderId}&type=${type}&isbulk=true`
    );
  };

  const handleView = (catalog) => {
    console.log("Open catalog", catalog);
    navigate(
      `/photos/catalogview?catalogId=${catalog.catalogId}&projectId=${projectId}&folderId=${folderId}&type=${type}&catalogId=${catalog.catalogId}`
    );
  };

  return (
    <>
      <CustomBreadcrumb />

      <SC.BodyContainer>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
      </SC.BodyContainer>

      <SC.LeasingLayout>
        {permission ? (
          <GetPermission folderId={folderId} isLoading={isLoading} />
        ) : null}
      </SC.LeasingLayout>

      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          padding: "10px",
          borderBottom: `1px solid ${theme.colors.bordertask}`,
          justifyContent: "space-between",
        }}
      >
        {permission > userAccessType.read && (
          <div
            style={{
              gap: "10px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div
              style={{
                gap: "15px",
                display: "flex",
                width: "100%",
              }}
            >
              <Button
                leftIcon={
                  <InnoIcons.AddIcon size={16} sx={{ fontSize: "17px" }} />
                }
                caption={"Upload photos & videos"}
                onClick={handleMultipleUpload}
                color="white"
                fontSize="12px"
                maxLength={30}
                style={{
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "150px",
                  height: "28px",
                  borderRadius: "3px",
                }}
              />
              <Button
                leftIcon={
                  <InnoIcons.AddIcon size={16} sx={{ fontSize: "17px" }} />
                }
                caption={"Bulk upload zipped photos & videos"}
                color="white"
                fontSize="12px"
                style={{
                  background: theme.gradient.themeGradient,
                  color: theme.colors.white,
                  minWidth: "200px",
                  height: "28px",
                  borderRadius: "3px",
                }}
                onClick={handleMultipleBulkUpload}
              />
            </div>
          </div>
        )}
        <SC.InputContiner>
          <SC.SearchIcon />
          <SC.InputStyle
            placeholder="Search catalogs by name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {/* {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  style={{
                    marginLeft: 8,
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: theme.colors.textPrimary,
                  }}
                  aria-label="Clear search"
                >
                  Clear
                </button>
              )} */}
        </SC.InputContiner>
      </div>

      <div style={{ padding: "10px" }}>
        {loading ? (
          <ShimmerCard />
        ) : filteredCatalogs.length === 0 ? (
          <div style={{ padding: 20, textAlign: "center", color: "#666" }}>
            {catalogs.length === 0
              ? "No catalogs available."
              : "No catalogs match your search."}
          </div>
        ) : (
          <CatalogGrid catalogs={filteredCatalogs} onView={handleView} />
        )}
      </div>
    </>
  );
});

export default Photos;
